function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import CoreSlider from './core';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';

import './slider.css';

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    var _temp, _this, _ret;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (value, position) {
      if (isFunction(_this.props.onChange)) {
        _this.props.onChange(value, position);
      }
    }, _this.render = function () {
      return React.createElement(
        'div',
        { className: 'slider-container-component' },
        React.createElement(CoreSlider, {
          markerLabel: _this.props.markerLabel,
          max: _this.props.max,
          min: _this.props.min,
          ref: 'slider',
          ticks: _this.props.ticks,
          value: _this.props.value,
          onChange: _this.handleChange
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Slider;
}(Component);

Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  markerLabel: PropTypes.array,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  ticks: PropTypes.bool,
  value: PropTypes.number
} : {};

export default Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-react-slider/es/index.js
// module id = 247
// module chunks = 0